import Ajax from '../js/common/ajax';

export default {
    // 日记账
    journal: {
        list(params = {}) { return Ajax.get('/cashier-journal', params); },
        load(id) { return Ajax.get(`/cashier-journal/${id}`); },
        delete(id) { return Ajax.delete(`/cashier-journal/${id}`); },
        save(params = {}) { return Ajax.post('/cashier-journal', params); },
        update(params = {}) { return Ajax.put('/cashier-journal', params); },
        /** 下拉选项：账户/收支类别/科目/币别/凭证字/银行 */
        options() { return Ajax.get('/cashier-journal/options'); },
        /** 资金报表 groupBy=account|ioType */
        report(params = {}) { return Ajax.get('/cashier-journal/report', params); },
        /** 核对总账 */
        check(params = {}) { return Ajax.get('/cashier-journal/check', params); },
        /** 批量生成凭证 */
        generateVoucher(ids) { return Ajax.post('/cashier-journal/generate-voucher', ids); },
        /** 导入日记账（Excel） */
        importData(formData) { return Ajax.post('/cashier-journal/import', formData); }
    },
    // 内部转账
    transfer: {
        list(params = {}) { return Ajax.get('/cashier-transfer', params); },
        load(id) { return Ajax.get(`/cashier-transfer/${id}`); },
        delete(id) { return Ajax.delete(`/cashier-transfer/${id}`); },
        save(params = {}) { return Ajax.post('/cashier-transfer', params); },
        update(params = {}) { return Ajax.put('/cashier-transfer', params); },
        batchDelete(ids) { return Ajax.post('/cashier-transfer/batch-delete', ids); },
        generateVoucher(ids) { return Ajax.post('/cashier-transfer/generate-voucher', ids); },
        /** 导入内部转账（Excel） */
        importData(formData) { return Ajax.post('/cashier-transfer/import', formData); }
    },
    // 收支类别
    ioType: {
        list(params = {}) { return Ajax.get('/cashier-io-type', params); },
        load(id) { return Ajax.get(`/cashier-io-type/${id}`); },
        delete(id) { return Ajax.delete(`/cashier-io-type/${id}`); },
        save(params = {}) { return Ajax.post('/cashier-io-type', params); },
        update(params = {}) { return Ajax.put('/cashier-io-type', params); },
        match(summary) { return Ajax.get('/cashier-io-type/match', { summary }); }
    },
    // 资金账户
    account: {
        list(params = {}) { return Ajax.get('/cashier-account', params); },
        load(id) { return Ajax.get(`/cashier-account/${id}`); },
        delete(id) { return Ajax.delete(`/cashier-account/${id}`); },
        save(params = {}) { return Ajax.post('/cashier-account', params); },
        update(params = {}) { return Ajax.put('/cashier-account', params); }
    }
};
